module.exports = __webpack_public_path__ + "img/drag-dots.52297aad.svg";